module.exports = __webpack_public_path__ + "img/LU.ec99c104.png";